export const sanitizeSlug = (
  value: string,
  addLeadingSlash = true,
  removeTrailingSlash = false,
): string => {
  if (value.match(/^(http|https|ftp|www)/g)) {
    return value;
  }

  let slug = value
    // regex to prevent replacing index if it is part of a word
    .replace(/(\/|^)index(\/|$)/gi, '');

  // add a leading '/' if the slug does not start with one
  if (!slug.startsWith('/') && addLeadingSlash) {
    slug = `/${slug}`;
  }

  // add a slash before the anchor but not if the slug contains a query
  if (slug.match(/#(?=\w)/gi) && !slug.match(/\?/gi)) {
    slug = slug.replace(/#(?=\w)/gi, '/#');
  }

  // remove slash before the anchor if the slug contains a query
  if (slug.match(/\/#(?=\w)/gi) && slug.match(/\?/gi)) {
    slug = slug.replace(/\/#(?=\w)/gi, '#');
  }

  // add a trailing slash to none file related slugs if it is missing
  if (!slug.match(/\.([^/]*)($|\/$)/gi) && !slug.endsWith('/')) {
    slug = `${slug}/`;
  }

  // remove a trailing slash behind a local file or anchor
  if (slug.match(/\.([^/]*)($|\/$)/gi) && slug.match(/^\/(.*)\/$/gi)) {
    slug = slug.slice(0, -1);
  }

  // remove the trailing slash behind an anchor
  if (slug.match(/#([\w\-_])*\/$/gi)) {
    slug = slug.slice(0, -1);
  }

  // remove the trailing slash behind a query
  if (slug.match(/\?.*\/$/gi)) {
    slug = slug.slice(0, -1);
  }

  // remove the leading slash before a query
  if (slug.match(/\/\?/gi)) {
    slug = slug.replace('/?', '?');
  }

  // remove an empty query at the end of a slug
  if (slug.match(/\?$/gi)) {
    slug = slug.replace(/\?$/gi, '');
  }

  // remove an emtpy query before an anchor
  if (slug.match(/\?#/gi)) {
    slug = slug.replace('?#', '#');
  }

  if (slug.match(/:\/\//gi)) {
    const temp = slug.split('://');
    temp[1] = temp[1].replace(/\/\/+/gi, '/');
    slug = temp.join('://');
  } else {
    slug = slug
      // clean up the string if there are multiple '/' behind each other
      // but skip '://'
      .replace(/\/\/+/gi, '/');
  }

  if (removeTrailingSlash && slug.endsWith('/')) {
    slug = slug.slice(0, -1);
  }

  return slug;
};
